module.exports = __webpack_public_path__ + "img/company.56c7fe70.jpg";